import {
  ComplianceEntity,
  VerificationLaneKind,
  VerificationLaneStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The Tax-lane verification status of a payer-owned compliance entity — the v3
 * equivalent of the v1 `payeeW9Data.payeeTinVerification.status` the
 * edit-tax-info flow polls (Verified / Failed / Pending / …). Returns undefined
 * when the entity has no Tax lane yet. Flattens across jurisdictions (the payer-
 * supplied contractor flow is US-only, so there is a single Tax lane).
 */
export const selectorComplianceEntityTaxLaneStatus = (
  complianceEntity?: ComplianceEntity | null
): VerificationLaneStatus | undefined =>
  (complianceEntity?.verificationStatus?.statuses ?? [])
    .flatMap(jurisdiction => jurisdiction.lanes ?? [])
    .find(lane => lane.kind === VerificationLaneKind.TAX)?.status;
